<template>
  <div class="playing flex justify-center items-center p-3 border-box items-end w-full h-full m-auto">
    <span class="playing__bar playing__bar1 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar2 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar3 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar4 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar5 rounded-xl ml-1 bg-white inline-block"></span>
    <span class="playing__bar playing__bar6 rounded-xl ml-1 bg-white inline-block"></span>
  </div>
</template>

<style lang="scss" scoped>
.playing {
  width: 70%;
  height: 60%;

  @screen md {
    width: 80%;
    height: 70%;
  }
}

.playing__bar {
  width: 5px;
  height: 10px;
  animation: up-and-down-mobile 1.3s ease infinite alternate;

  @screen md {
    animation: up-and-down-desktop 1.3s ease infinite alternate;
  }
}

.playing__bar1 {
  height: 32px;
}

.playing__bar2 {
  height: 72px;
  animation-delay: -2.2s;
}

.playing__bar3 {
  height: 35px;
  animation-delay: -3.7s;
}

.playing__bar4 {
  height: 47px;
  animation-delay: -4.3s;
}

.playing__bar5 {
  height: 28px;
  animation-delay: -4.9s;
}

.playing__bar6 {
  height: 10px;
  animation-delay: -5.4s;
}

@keyframes up-and-down-mobile {
  10% {
    height: 10px;
  }

  30% {
    height: 49px;
  }

  60% {
    height: 20px;
  }

  80% {
    height: 35px;
  }

  100% {
    height: 27px;
  }
}

@keyframes up-and-down-desktop {
  10% {
    height: 30px;
  }

  30% {
    height: 89px;
  }

  60% {
    height: 50px;
  }

  80% {
    height: 75px;
  }

  100% {
    height: 60px;
  }
}
</style>
